export const pelanggan = {
  cilegon: 1,
  serang: 2,
  tangerang: 3,
  bekasi: 4,
  jatinegara: 5,
  rawamangun: 6,
  karawang: 7,
  testing: 8,
  daanmogot: 9,
  malang: 10,
  jakartapusat: 11,
  harmoni: 12,
  kramat: 13,
  pecenongan: 14,
  jababeka: 15,
  indramayu: 16,
  tanjungkarang: 17,
  klaten: 18,
  ugm: 19,
};

export const cabangs = [
  { title: "UGM", key: "ugm" },
  { title: "Klaten", key: "klaten" },
  { title: "Tanjung Karang", key: "tanjungkarang" },
  { title: "Indramayu", key: "indramayu" },
  { title: "Jababeka", key: "jababeka" },
  { title: "Pecenongan", key: "pecenongan" },
  { title: "Kramat", key: "kramat" },
  { title: "Harmoni", key: "harmoni" },
  { title: "Jakarta Pusat", key: "jakartapusat" },
  { title: "Malang", key: "malang" },
  { title: "Daan Mogot", key: "daanmogot" },
  { title: "Karawang", key: "karawang" },
  { title: "Rawamangun", key: "rawamangun" },
  { title: "Jatinegara", key: "jatinegara" },
  { title: "Bekasi", key: "bekasi" },
  { title: "Tangerang", key: "tangerang" },
  { title: "Serang", key: "serang" },
  { title: "Cilegon", key: "cilegon" },
];
